// A Files snapshot belongs to Files' substrate-filtered prompt window. Other
// X-ray views deliberately use different windows, so their keys cannot decide
// whether the saved Files offsets are stale.
export function shouldResetFilesScrollSnapshot({ view, previousView, windowPending, savedWindowKey, windowKey }) {
  return view === "files" && previousView === "files" && !windowPending && savedWindowKey !== windowKey;
}
